import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

const DropzoneVideo = ({ onVideoSelect }) => {
  const [videoDropzone, setVideoDropzone] = useState(null);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: { "video/*": [] },
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      const updatedFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      setVideoDropzone(updatedFiles);
      onVideoSelect(updatedFiles[0]);
    },
  });

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const handleDelete = () => {
    URL.revokeObjectURL(videoDropzone[0].preview);
    setVideoDropzone(false);
    onVideoSelect(null); // Reset the video URL
  };

  const thumbs = videoDropzone ? (
    <div className="thumbnail">
      <div className="bg-thumbnailImage">
        <video
          src={videoDropzone[0].preview}
          alt={videoDropzone[0].name}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            borderRadius: "15px",
            width: "128px",
            height: "90px",
          }}
          controls
        />
      </div>
      <button className="delete-btn videoDropzone" onClick={handleDelete}>
        &#x2715;
      </button>
    </div>
  ) : null;

  return (
    <>
      <div>
        <div {...getRootProps({ className: dropzoneClass })}>
          <input {...getInputProps()} />
          {videoDropzone ? null : (
            <div className="p-2">Drop or select video here...</div>
          )}
          {thumbs}
        </div>
      </div>
    </>
  );
};

export default DropzoneVideo;
